import React from "react";
import Cards from "../components/Card";
import HeroSection from "../components/HeroSection";

function Home() {
	return (
		<>
			<HeroSection />
			<Cards />
		</>
	);
}

export default Home;
